var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarningIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.831 11.124C17.5626 11.124 19.775 8.91152 19.775 6.17996C19.775 3.4484 17.5626 1.23596 14.831 1.23596C12.0995 1.23596 9.88703 3.4484 9.88703 6.17996C9.88703 8.91152 12.0995 11.124 14.831 11.124ZM14.831 3.70796C16.1906 3.70796 17.303 4.82036 17.303 6.17996C17.303 7.53956 16.1906 8.65196 14.831 8.65196C13.4714 8.65196 12.359 7.53956 12.359 6.17996C12.359 4.82036 13.4714 3.70796 14.831 3.70796ZM14.831 14.2758C11.9141 11.5566 8.00831 9.88796 3.70703 9.88796V23.484C8.00831 23.484 11.9141 25.1526 14.831 27.8718C17.748 25.1649 21.6538 23.484 25.955 23.484V9.88796C21.6538 9.88796 17.748 11.5566 14.831 14.2758ZM23.483 21.1726C20.356 21.5929 17.3896 22.7794 14.831 24.6582C12.2849 22.7794 9.30611 21.5805 6.17903 21.1603V12.5701C8.77463 13.0398 11.1848 14.2387 13.1501 16.068L14.831 17.65L16.512 16.0803C18.4772 14.251 20.8874 13.0521 23.483 12.5824V21.1726V21.1726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningIconLight);
export default __webpack_public_path__ + "static/media/EarningIconLight.3fae7d4e010d2a29d6fca07d44bc6ab9.svg";
export { ForwardRef as ReactComponent };